module.exports = __webpack_public_path__ + "img/pay-icon-5.2ed8d2c8.png";